module.exports = __webpack_public_path__ + "assets/img/middle3.2d959f14.png";